import client from "./client";

export interface Contact {
  id: number;
  userId: number;
  phone: string;
  address: string;
  street: string;
  status: "pending" | "done";
  createdAt: string;
}

export const contactsApi = {
  getMy: () =>
    client.get<Contact>("/contacts/my"),

  upsert: (data: {
    phone: string;
    address?: string;
    street?: string;
    status?: string;
  }) => client.post<Contact>("/contacts", data),
};
